export const DEFAULT_VERTICAL_SCROLL_OFFSET = 200
export const DEFAULT_VERTICAL_SCROLL_THROTTLE = 200
export const DEFAULT_HORIZONTAL_SCROLL_CARD_MARGIN_MOBILE = 8
export const DEFAULT_HORIZONTAL_SCROLL_CARD_MARGIN_DESKTOP = 16
